import Vue from 'vue';

export default {
  state: {
    photosList: [],
    currentPhotos: {},

    videosList: [],
  },
  mutations: {
    setPhotosList(state, data) {
      state.photosList = data;
    },
    setCurrentPhotos(state, data) {
      state.currentPhotos = data;
    },

    setVideosList(state, data) {
      state.videosList = data;
    },
  },
  actions: {
    getPhotosList(store) {
      const path = 'photoarchives?_sort=date:desc';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setPhotosList', resp.data);
        return resp.data;
      });
    },
    getPhotosById(store, id) {
      const path = `photoarchives/${id}`;
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setCurrentPhotos', resp.data);
        return resp.data;
      });
    },

    getVideosList(store) {
      const path = 'videoarchives?_sort=date:desc';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setVideosList', resp.data);
        return resp.data;
      });
    },
  },
};
